
class ProductsHelper  {

    static Get(orders, changes) {
        const products=[];
        orders && orders.map((order,idx) => {
            order.lines.map((line, idx2)=> {
                line.id=order.docEntry + "-" + line.sequenceNumber
                products.push(line);
                return false;
            });
            return false;
        });

        // add the added products from changes
        changes.productsAdded && changes.productsAdded.map((product,idx) => {
            product.isAdded=true;       // needed to know if we can change the quantity
            products.push(product);
            return false;
        });

        // remove the removed products from changes
        changes.productsRemoved && changes.productsRemoved.map((product,idx) => {
            // find the index
            var index=products.findIndex(p=>p.id===product.id);
            products.splice(index, 1); 
            return false;
        });
        //console.log(products);

        return products;
    }    
    
}

export default ProductsHelper